<template>
  <div class="pt-select-view__wrapper">
    <div v-if="userPick === null">
      <select
        v-if="
          getPromoStatus === 0 &&
            (getPromoConfig.loggedIn || getPromoConfig.isLoggedIn)
        "
        class="pt-select-view__select"
        v-model="selectedTeam"
      >
        <option value="">{{
          config.FieldValues.Parameters.select_default_option
        }}</option>
        <option v-for="(team, i) in getSelectedTeams" :key="i" :value="team"
          >{{ team.name }} - {{ team.casino === null ? "" : team.casino.name }}
        </option>
      </select>
      <button
        v-if="
          getPromoStatus === 0 &&
            (getPromoConfig.loggedIn || getPromoConfig.isLoggedIn)
        "
        class="pt-button"
        :disabled="selectedTeam === ''"
        :aria-label="config.FieldValues.Parameters.label_select"
        @click="sendSelection"
        v-html="config.FieldValues.Parameters.label_select"
      />
      <div
        class="pt-select-view__closed"
        v-if="getPromoStatus === -1"
        v-html="config.FieldValues.Parameters.label_closed"
      ></div>
    </div>
    <div class="pt-select-view__selected__wrapper" v-else>
      <div class="pt-select-view__selected">
        {{ config.FieldValues.Parameters.label_selected }}
        <b>{{ getProperTeamData.name }}</b> ({{
          getProperTeamData.casino.name
        }})
      </div>
      <div class="pt-select-view__wager">
        {{ config.FieldValues.Parameters.label_wager_message }}
        <strong
          >{{ getWagerAmount
          }}{{ config.FieldValues.Parameters.label_currency }}</strong
        >
      </div>
      <div
        v-if="getPromoStatus === 0"
        class="pt-select-view__wager-message"
        v-html="wagerMessage"
      ></div>
      <div
        v-if="getPromoStatus === -1"
        v-html="config.FieldValues.Parameters.label_closed_participated"
      ></div>
      <a
        v-if="getPromoStatus === 0"
        class="pt-button pt-button--link"
        :href="getGameUrl"
        >{{ config.FieldValues.Parameters.label_play_game }}
        {{ getProperTeamData.casino.name }}</a
      >
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import store from "@/store/store";
import { mapGetters } from "vuex";
export default {
  props: {
    config: Object,
    userPick: Object
  },
  data() {
    return {
      selectedTeam: ""
    };
  },
  computed: {
    ...mapGetters([
      "getPromoConfig",
      "getSelectedTeams",
      "getLeagueViewData",
      "getPromoStatus",
      "getApiData"
    ]),
    getProperTeamData() {
      const league = this.getLeagueViewData.find(
        item => item.id === this.userPick.domestic.leagueid
      );
      return league.teams.find(
        item => item.id === this.userPick.domestic.teamid
      );
    },
    getWagerAmount() {
      return this.getApiData.wager === null ? "0.00" : this.getApiData.wager;
    },
    getGameUrl() {
      const urlDesktop =
        this.getProperTeamData.casino.externalId === ""
          ? `https://casino.${this.getPromoConfig.label}/${
              this.getPromoConfig.language
            }`
          : `https://casino.${this.getPromoConfig.label}/${
              this.getPromoConfig.language
            }/casino/launchng/${this.getProperTeamData.casino.externalId}`;
      const urlMobile =
        this.getProperTeamData.casino.externalMobileId === ""
          ? `https://casino.m.${this.getPromoConfig.label}/${
              this.getPromoConfig.language
            }/casino`
          : `https://casino.m.${this.getPromoConfig.label}/${
              this.getPromoConfig.language
            }/casino/launchng/${
              this.getProperTeamData.casino.externalMobileId
            }`;
      return this.getPromoConfig.isMobile === "True" ? urlMobile : urlDesktop;
    },
    wagerMessage() {
      return this.getWagerAmount === "0.00"
        ? this.config.FieldValues.Parameters.label_start_wager
        : this.config.FieldValues.Parameters.label_continue_wager;
    }
  },
  methods: {
    sendSelection() {
      store.dispatch("sendLeagueData", this.selectedTeam);
    }
  }
};
</script>
<style lang="scss">
.pt-select-view {
  &__wrapper {
    color: var(--pyt-wrapper-color);
    padding-top: 20px;
  }
  &__closed {
    margin-bottom: 10px;
  }
  &__select {
    appearance: none;
    background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAgBAMAAACiDzYSAAAAIVBMVEX///9lZWXIyMjJycnOzs7Pz8/R0dHl5eXm5ub19fX6+vr+X3tiAAAAAXRSTlMAQObYZgAAAGRJREFUeF7dy7ENgFAQAlBiobFEq9/pOlaO5Ai6g4Maiwt3YQKlgpCHb+auc1Nly8dFdfLUGJmelS2TWaN7kciCgkQmwJCIIRFDIhmJGBIxFMRREEdBHAVxJFLTk7tWyXDgF3kAY+EPSPiQV7gAAAAASUVORK5CYII=")
      right center no-repeat;
    background-size: 1.4em auto;
    border-radius: 3px;
    cursor: pointer;
    height: 44px;
    margin-bottom: 20px;
    max-width: 95%;
    padding: 11px 22px 11px 11px;
  }
  &__selected {
    font-size: 17px;
    margin-bottom: 20px;

    &__wrapper {
      margin-bottom: 20px;
    }
  }
  &__wager {
    margin-bottom: 10px;
    &-message {
      margin-bottom: 20px;
    }
  }
}
</style>
